<div class="modal-header">
  <h5 class="modal-title">
    <span *ngIf="reportType === 'departments'">Afdelingenrapportage</span>
    <span *ngIf="reportType === 'overtime'">Rapport overuren</span>
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div *ngIf="reportType === 'departments'">
    <table class="table table--striped">
      <thead>
        <tr>
          <th>Type</th>
          <th>Percentage</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dept of getDepartmentsSorted()">
          <td>{{ dept.label }}</td>
          <td>{{ getTimesheetPercentageTotals(dept.key) }}%</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="reportType === 'billed'">
    <table class="table table--striped">
      <thead>
        <tr>
          <th>Department</th>
          <th>Billed hours</th>
          <th>Total hours</th>
          <th>% billed</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of getBilledByDepartment()">
          <td>{{ r.label }}</td>
          <td>{{ r.billedLabel }}</td>
          <td>{{ r.totalLabel }}</td>
          <td>{{ r.percent }}%</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="reportType === 'overtime'">
    <table class="table table--striped">
      <thead>
        <tr>
          <th>Medewerker</th>
          <th>Gewerkte uren</th>
          <th>Verplichte uren</th>
          <th>Verschil</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let e of getOverUnderEntries()" class="pointer" (click)="showBreakdown(e.tsUuid)">
          <td>{{ e.employee }}</td>
          <td>{{ e.totalHours }}</td>
          <td>{{ e.requiredHours }}</td>
          <td [class.color--red]="e.differenceHours < 0" [class.color--green]="e.differenceHours > 0">{{ e.differenceHours }}</td>
          <td>{{ e.type }}</td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="selectedTimesheet" style="margin-top: 16px;">
      <h6>Uitsplitsing projecten — {{ selectedTimesheet?.employee?.firstName }} {{ selectedTimesheet?.employee?.lastName }}</h6>
      <table class="table table--striped">
        <thead>
          <tr>
            <th>Project</th>
            <th>Gewerkte uren</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of projectBreakdown">
            <td>{{ p.project }}</td>
            <td>{{ p.hours }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="button" (click)="activeModal.close()">Close</button>
</div>
